<template>
<div>
  <div class="wrap" id="wrap" @click="hideDropdown($event), hideKeywordDropdown()">
    <div class="loading_gif" v-show="loading" style="position: fixed; max-width:640px">
      <img src="../../../static/images/loading.gif" class="loading-img">
      <p style="font-size:14px; color: #FFFFFF;">数据加载中,请稍等...</p>
    </div>

    <div class="wrapper" v-show="currentuser && !smartEngine.open">
      <!--统计-->
      <div class="stat-analyze" v-show="!showResultPage && !showSearchPage && showTongjiPage">
        <div class="search-header">
          <div class="search-header-text" @click="switchPage(2), setCnzz('[Mobile]-信披搜索', '从统计页返回搜索结果页', '')">
            <span class="arrow-back"></span>统计
          </div>
        </div>
        <div class="search-header-menu statis">
          <ul>
            <li @click="showStatAnalyze = true, showStatFilter = false, setCnzz('[Mobile]-信披搜索', '点击分析按钮', '')" :class="{on: showStatAnalyze}">分析</li>
            <li @click="showStatAnalyze = false, showStatFilter = true, setCnzz('[Mobile]-信披搜索', '点击筛选按钮', '')" :class="{on: showStatFilter}">筛选</li>
          </ul>
        </div>

        <!--分析-->
        <div class="Analysis-list" v-show="showStatAnalyze">
          <div class="Analysis-list-box"  v-if="currentuser">
            <span class="head">相关的公司</span>
            <ul>
              <li v-for="item in company"> {{ item.key }} </li>
            </ul>
          </div>
          <div class="Analysis-list-box"  v-if="currentuser">
            <span class="head">提到的公司</span>
            <ul>
              <li v-for="item in related_company">{{ item.key }}</li>
            </ul>
          </div>
          <div class="Analysis-list-box"  v-if="currentuser">
            <span class="head">相关人员</span>
            <ul>
              <li v-for="item in related_name">{{ item.key }}</li>
            </ul>
          </div>

          <div class="Analysis-list-box"  v-if="!currentuser">
            <span class="head">相关的公司</span>
            <ul>
              <li v-for="item in company"> {{ item.key }} </li>
            </ul>
          </div>
          <div class="Analysis-list-box"  v-if="!currentuser">
            <span class="head">提到的公司</span>
            <ul>
              <li v-for="item in related_company">{{ item.key }}</li>
            </ul>
          </div>
          <div class="Analysis-list-box"  v-if="!currentuser">
            <span class="head">相关人员</span>
            <ul>
              <li v-for="item in related_name">{{ item.key }}</li>
            </ul>
          </div>
        </div>

        <!--筛选-->
        <div class="Analysis-list" v-show="showStatFilter && searched===stype">
          <div class="Analysis-list-box" v-show="aggLabels.length>0">
            <span class="head">公告标签</span>
            <ul>
              <li v-for="d in aggLabels">
                <label class="el-checkbox mar" style="width: 75%">
                  <span class="el-checkbox-input" :class="{'is-checked': conditions['labels'][d.code]}">
                    <span class="el-checkbox-inner" @click.stop="addConditionNew('labels', d)"></span>
                    <input name="type" class="el-checkbox-original" value="全选" type="checkbox">
                  </span>
                  <span class="el-checkbox-label" @click.stop="addConditionNew('labels', d)">{{d.name | maxlen 8}}</span>
                </label>
                <span class="notice-right blue" style="float: right;">{{d.count}}</span>
              </li>
            </ul>
          </div>
          <div class="Analysis-list-box" v-show="aggTypes.length>0">
            <span class="head">公告类型</span>
            <ul>
              <li v-for="type in aggTypes">
                <label class="el-checkbox mar" style="width: 75%">
                  <span class="el-checkbox-input" :class="{'is-checked': conditions['type'][type.code]}">
                    <span class="el-checkbox-inner" @click.stop="addConditionNew('type', type)"></span>
                    <input name="type" class="el-checkbox-original" value="全选" type="checkbox"></span>
                  <span class="el-checkbox-label" @click.stop="addConditionNew('type', type)">{{type.name | maxlen 8}}</span>
                </label>
                <span class="notice-right blue" style="float: right;">
                  {{type.count}}
                </span>
              </li>
            </ul>
          </div>
          <div class="Analysis-list-box" v-show="aggPlates.length>0">
            <span class="head">板块类型</span>
            <ul>
              <li v-for="plate in aggPlates">
                <label class="el-checkbox mar" style="width: 75%">
                  <span class="el-checkbox-input" :class="{'is-checked': conditions['plate'][plate.code]}">
                    <span class="el-checkbox-inner" @click.stop="addConditionNew('plate', plate)"></span>
                    <input name="type" class="el-checkbox-original" value="全选" type="checkbox"></span>
                  <span class="el-checkbox-label" @click.stop="addConditionNew('plate', plate)">{{plate.name | maxlen 8}}</span>
                </label>
                <span class="notice-right blue" style="float: right;">
                  {{plate.count}}
                </span>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <!--搜索条件-->
      <div class="search-conditions" style="padding-bottom: 1.8rem;" v-show="!showResultPage && showSearchPage && !showTongjiPage">
        <!--1.页顶-->
        <div class="search-header">
          <div class="search-header-text" @click.stop="switchPage(2), setCnzz('[Mobile]-信披搜索', '从搜索条件页返回搜索结果页', '')">
            <span class="arrow-back"></span>搜索条件
          </div>
          <span class="search-header-stics" @click="showModalTag = true">保存标签</span>
        </div>
        

        <!--2. tab-->
        <div class="search-header-menu search-tab-scroll">
          <ul>
            <li :class="{activeTyp: stype == 100 }" style="margin-top:-2px;">
              <a href="javascript:;" v-on:click="changeStype(100), setCnzz('[Mobile]-信披搜索', '点击A股按钮', '')" style="color: #fff;">综合</a>
            </li>
            <li :class="{activeTyp: stype == 1 }" style="margin-top:-2px;">
              <a href="javascript:;" v-on:click="changeStype(1), setCnzz('[Mobile]-信披搜索', '点击A股按钮', '')" style="color: #fff;">A股</a>
            </li>
            <li :class="{activeTyp: stype == 2 }" style="margin-top:-2px;width:9%">
              <a href="javascript:;" v-on:click="changeStype(2), setCnzz('[Mobile]-信披搜索', '点击新三板按钮', '')" style="color: #fff;">新三板</a>
            </li>
            <li :class="{activeTyp: stype == 3 }" style="margin-top:-2px">
              <a href="javascript:;" v-on:click="changeStype(3), setCnzz('[Mobile]-信披搜索', '点击债券按钮', '')" style="color: #fff;">债券</a>
            </li>
            <li :class="{activeTyp: stype == 4 }" style="margin-top:-2px">
              <a href="javascript:;" v-on:click="changeStype(4), setCnzz('[Mobile]-信披搜索', '点击研报按钮', '')" style="color: #fff;">知识库</a>
            </li>
            <li :class="{activeTyp: stype == 5 }" style="margin-top:-2px">
              <a href="javascript:;" v-on:click="changeStype(5), setCnzz('[Mobile]-信披搜索', '点击问题库按钮', '')" style="color: #fff;">问题库</a>
            </li>
            <li :class="{activeTyp: stype == 6 }" style="margin-top:-2px">
              <a href="javascript:;" v-on:click="changeStype(6), setCnzz('[Mobile]-信披搜索', '点击港股按钮', '')" style="color: #fff;">港股</a>
            </li>
            
              <!-- 信披模块开发 -->
            <!-- <li :class="{activeTyp: stype == 7 }" style="margin-top:-2px;width:8.5%">
              <a href="javascript:;" v-on:click="changeStype(7), setCnzz('[Mobile]-信披搜索', '点击研报按钮', '')" style="color: #fff;">法院公告</a>
            </li>
            <li :class="{activeTyp: stype == 8 }" style="margin-top:-2px;width:8.5%">
              <a href="javascript:;" v-on:click="changeStype(8), setCnzz('[Mobile]-信披搜索', '点击研报按钮', '')" style="color: #fff;">裁判文书</a>
            </li>
            <li :class="{activeTyp: stype == 9 }" style="margin-top:-2px;width:8.5%">
              <a href="javascript:;" v-on:click="changeStype(9), setCnzz('[Mobile]-信披搜索', '点击研报按钮', '')" style="color: #fff;">政府公告</a>
            </li> -->
            <li :class="{activeTyp: stype == 10 }">
              <a href="javascript:;" v-on:click="changeStype(10), setCnzz('[Mobile]-信披搜索', '点击研报按钮', '')" style="color: #fff;">ABS</a>
            </li>
            <li :class="{activeTyp: stype == 11 }" style="margin-top:-2px">
              <a href="javascript:;" v-on:click="changeStype(11), setCnzz('[Mobile]-信披搜索', '点击研报按钮', '')" style="color: #fff;">研报</a>
            </li>
            <li :class="{activeTyp: stype == 12 }" style="margin-top:-2px">
              <a href="javascript:;" v-on:click="changeStype(12), setCnzz('[Mobile]-信披搜索', '点击研报按钮', '')" style="color: #fff;">新闻</a>
            </li>
            <!-- <li :class="{activeTyp: stype == 15 }" style="margin-top:-2px;width:8.5%">
              <a href="javascript:;" v-on:click="changeStype(15), setCnzz('[Mobile]-信披搜索', '点击研报按钮', '')" style="color: #fff;">我的文档</a>
            </li> -->
          </ul>
        </div>

        <!--3. 搜索-->
        <div class="search-input-share">
          <div class="fl search-type">
            <div class="search-input btn-group">
              <div @click.stop="slideDropdown2($event)">
                {{ ttype_name }}
                <span class="close-bot"></span>
              </div>
              <ul class="date-menu close">
                <li><a href="javascript:;" v-show="ttype!=0" @click="ttype=0">全部</a></li>
                <li><a href="javascript:;" v-show="ttype!=1" @click="ttype=1">标题</a></li>
                <li><a href="javascript:;" v-show="ttype!=2 && showSubTitle" @click="ttype=2">章节标题</a></li>
                <li><a href="javascript:;" v-show="ttype!=3" @click="ttype=3">正文</a></li>
                <li><a href="javascript:;" v-show="stype == 5 && ttype!=4" @click="ttype=4">问题</a></li>
                <li><a href="javascript:;" v-show="stype == 5 && ttype!=5" @click="ttype=5">答案</a></li>
                <li><a href="javascript:;" v-show="stype == 11 && ttype!=6" @click="ttype=6">图片</a></li>
              </ul>
            </div>
            <input class="input-search-a" autofocus="autofocus" type="text" placeholder="" value="" v-model="keywords">
          </div>
          <!--搜索按钮-->
          <div class="fr"><a class="search-bot" @click="mySearch(), setCnzz('[Mobile]-信披搜索', '点击搜索按钮', '')"></a></div>
        </div>

        <!--智能引擎-->
        <div class="search-input-engine">
          <label class="el-checkbox el-mar">
            <span class="el-checkbox-input" :class="{'is-checked': ai === 1}">
              <span class="el-checkbox-inner" @click.stop="smartBtn(), setCnzz('[Mobile]-信披搜索', '点击智能引擎按钮', '')"></span>
              <input type="checkbox" name="type" class="el-checkbox-original ">
            </span>
            <span class="el-checkbox-label el-text">智能引擎</span>
          </label>
        </div>

        <!--4. 关键词-->
        <div class="Key-word">
          <h3 class="">关键词</h3>
          <ul>
            <li v-for="ky in keywords_condition" track-by="$index">
              <div class="Key-word-box">
                <div class="screen-menu">
                  <div class="release-date btn-group">
                    <div @click.stop="slideDropdown2($event)">
                      {{ ky.ttname }}
                      <span class="close-bot"></span>
                    </div>
                    <ul class="date-menu close" style="left: -0.5rem; width: 7rem">
                      <li v-show="ky.ttype!=0"><a href="javascript:;" @click="changeKyTtype(ky, 0, '全部')">全部</a></li>
                      <li v-show="ky.ttype!=1"><a href="javascript:;" @click="changeKyTtype(ky, 1, '标题')">标题</a></li>
                      <li v-show="ky.ttype!=2 && showSubTitle"><a href="javascript:;" @click="changeKyTtype(ky, 2, '章节标题')">章节标题</a></li>
                      <li v-show="ky.ttype!=3"><a href="javascript:;" @click="changeKyTtype(ky, 3, '正文')">正文</a></li>
                      <li v-show="stype == 5 && ky.ttype!=4"><a href="javascript:;" @click="changeKyTtype(ky, 4, '问题')">问题</a></li>
                      <li v-show="stype == 5 && ky.ttype!=5"><a href="javascript:;" @click="changeKyTtype(ky, 5, '答案')">答案</a></li>
                    </ul>
                  </div>

                  <span class="release-line"></span>
                  <div class="release-date btn-group">
                    <div @click.stop="slideDropdown2($event)">
                      {{ ky.opname }}
                      <span class="close-bot"></span>
                    </div>
                    <ul class="date-menu close" style="left: -0.4rem; width: 7rem;">
                      <li v-show="ky.optype!=1"><a href="javascript:;" @click="changeKyOp(ky, 1, '包含全部关键词')">包含全部关键词</a></li>
                      <li v-show="ky.optype!=2"><a href="javascript:;" @click="changeKyOp(ky, 2, '包含任意关键词')">包含任意关键词</a></li>
                      <li v-show="ky.optype!=3"><a href="javascript:;" @click="changeKyOp(ky, 3, '不含全部关键词')">不含全部关键词</a></li>
                    </ul>
                  </div>
                </div>
                <span class="text-box" style="width: 94%; margin-left: 8px">
                 <input autocomplete="off" maxlength="255" v-model="ky['val']" placeholder="多个词以空格隔开" class="input-search-b" name="wd" id="kw">
               </span>
                <div class="text-btn">
                  <a href="javascript:;" class="btn-add" @click="addKeywordCondition(), setCnzz('[Mobile]-信披搜索', '点击添加关键词按钮', '')" v-if="$index === 0">添加</a>
                  <a href="javascript:;" class="btn-delete" @click="rmvKeywordCondition($index), setCnzz('[Mobile]-信披搜索', '点击删除关键词按钮', '')" v-if="$index > 0">删除</a>
                </div>
              </div>
            </li>
          </ul>
        </div>

        <!--5. 公告信息-->
        <div class="Announ-list">
          <h3 class="">公告信息</h3>
          <div class="Announ-list-box">
          <span class="text-box">
            <input type="text" class="input-search-b" placeholder="{{pholder}}" v-model="companyCode"  @keyup="suggest(companyCode, $event)" style="border: none;width: 100%;">
            <!--  <ul class="company-menu" v-if="suggestions.length > 0" tabindex="-1" @keydown.stop="arrowkey($event)">
                <li v-for="i in suggestions" @click="companyCode = i[0], oldsuggestValue = i[0], suggestions = []" tabindex="-1" @keyup.13="oldsuggestValue = i[0], suggestions = [], companyCode = i[0]">
                  <span class="left">{{i[2]}}</span><span class="right">{{i[0]}}</span>

                </li>
             </ul> -->
             <ul class="company-menu" v-if="suggestions.length > 0" tabindex="-1">
                <li v-for="i in suggestions" @click="companyCode = i[0], oldsuggestValue = i[0], queue = [], suggestNum = -1, suggestions = []" tabindex="-1">
                  <span class="left">{{i[2]}}</span><span class="right">{{i[0]}}</span>

                </li>
             </ul>
          </span>
            <div @click="alertDateModal">
              <p class="date">发布日期</p>
              <p class="time">
                <span class="l">{{startdate}}</span>
                至
                <span class="r">{{enddate}}</span>
              </p>
            </div>
          </div>
        </div>
         <!-- 日期筛选   -->
        <div v-show="showDateModal">
          <div aria-hidden="false" aria-labelledby="myModalLabel" role="dialog" tabindex="-1" id="dialog" class="modal fade in" style="display: block;">
            <div class="Release-date" id="Release-date">
              <p class="date"> 发布日期 </p>
              <div class="home-nav-app btn-group">
                <div @click.stop="slideDropdown('post_time')">
                  <span class="select-name">{{ datetype_name }}</span>
                  <span class="arrow-img">
                  <img src="../../../static/images/arrow-down.svg" alt="" v-show="showDropdownMenu !== ''">
                  <img src="../../../static/images/arrow-right.svg" alt="" v-show="showDropdownMenu == ''">
                </span>
                </div>
                <ul class="lanmu slide-menu date-slide-menu" v-show="showDropdownMenu == 'post_time'">
                  <li @click="changeDateType(1)"><a href="javascript:;">一个月</a></li>
                  <li @click="changeDateType(2)"><a href="javascript:;">一个季度</a></li>
                  <li @click="changeDateType(3)"><a href="javascript:;">半年</a></li>
                  <li @click="changeDateType(4)"><a href="javascript:;">去年</a></li>
                  <li @click="changeDateType(5)"><a href="javascript:;">今年</a></li>
                  <li @click="changeDateType(6)"><a href="javascript:;">一年</a></li>
                  <li @click="changeDateType(7)"><a href="javascript:;">两年</a></li>
                  <li @click="changeDateType(8)"><a href="javascript:;">三年</a></li>
                  <li @click="changeDateType(9)"><a href="javascript:;">五年</a></li>
                  <li @click="changeDateType(10)"><a href="javascript:;">十年</a></li>
                  <li @click="changeDateType(98)"><a href="javascript:;">全部</a></li>
                  <li @click="changeDateType(99)"><a href="javascript:;">自定义</a></li>
                </ul>
              </div>
              <p class="time">
              <span class="l" style="overflow: hidden;">
                <date-picker :time.sync="startdate" :option="datepicker.option" :datetype.sync="datetype"></date-picker>
              </span>
                至
                <span class="r" style="overflow: hidden;">
                <date-picker :time.sync="enddate" :option="datepicker.option" :datetype.sync="datetype"></date-picker>
              </span>
              </p>
              <p class="btn-confim">
                <a class="btn-cancel" @click.stop="showDateModal = false, cancelDate()">取消</a>
                <a class="btn-Determine" @click.stop="showDateModal = false, confirmDate()">确定</a>
              </p>
            </div>
          </div>
          <div class="modal-backdrop fade in" @click.stop="showDateModal = false"></div>
        </div>

        <!--6. 筛选条件-->
        <div class="Announ-list" v-if="showTypAll">
          <h3 class="">筛选条件</h3>
          <div class="Announ-list-box">
            <ul>
              <!--公告类型-->
              <template v-if="showType">
                <li>
                  <p class="date"> 公告类型 </p>
                  <p class="time" @click.stop="showCondition('type')">
                    <span v-if="isEmptyObj(conditions['type'])">全部</span>
                    <span v-for="(code, name) in conditions['type']" style="margin-right: 8px">{{name}}</span>
                  </p>
                </li>
              </template>
              <!--问题类型-->
              <template v-if="showQaType">
                <li>
                  <p class="date"> 问题类型 </p>
                  <p class="time" @click.stop="showCondition('qaType')">
                    <span v-if="isEmptyObj(conditions['qaType'])">全部</span>
                    <span v-for="(code, name) in conditions['qaType']" style="margin-right: 8px">{{name}}</span>
                  </p>
                </li>
              </template>
              <!--板块类型-->
              <template v-if="showPlate">
                <li>
                  <p class="date"> 板块类型 </p>
                  <p class="time" @click.stop="showCondition('plate')">
                    <span v-if="isEmptyObj(conditions['plate']) && isEmptyObj(conditions['layer'])">全部</span>
                    <template v-if="pageshowConditions['plate']['挂牌公司'].length > 0">
                      <span style="margin-right: 8px">挂牌公司</span>
                      <span v-for="c in pageshowConditions['plate']['挂牌公司']" style="margin-right: 8px">{{c}}</span>
                    </template>
                    <template v-if="pageshowConditions['plate']['N3BTS'] !== ''">
                      <span style="margin-right: 8px">两网及退市公司</span>
                    </template>
                    <template v-if="pageshowConditions['plate']['SHZB'] !== ''">
                      <span style="margin-right: 8px">上证主板</span>
                    </template>
                    <template v-if="pageshowConditions['plate']['SZCYB'] !== ''">
                      <span style="margin-right: 8px">创业板</span>
                    </template>
                    <template v-if="pageshowConditions['plate']['SZZB'] !== ''">
                      <span style="margin-right: 8px">深市主板</span>
                    </template>
                    <template v-if="pageshowConditions['plate']['SZZXB'] !== ''">
                      <span style="margin-right: 8px">中小板</span>
                    </template>
                  </p>
                </li>
              </template>
              <!--地区类型-->
              <template v-if="showRegion">
                <li>
                  <p class="date"> 地区类型 </p>
                  <p class="time" @click.stop="showCondition('region')">
                    <span v-if="isEmptyObj(conditions['region'])">全部</span>
                      <span v-for="(code, name) in conditions['region']" style="margin-right: 8px">{{name}}</span>
                  </p>
                </li>
              </template>
              <!--主板券商-->
              <template v-if="showSecurityCompany">
                <li>
                  <p class="date"> 主板券商 </p>
                  <p class="time" @click.stop="showCondition('securityCompany')">
                    <span v-if="isEmptyObj(conditions['securityCompany'])">全部</span>
                      <span v-for="(code, name) in conditions['securityCompany']" style="margin-right: 8px">{{name}}</span>
                  </p>
                </li>
              </template>
              <!--行业分类-->
              <template v-if="showIndustry">
                <li>
                  <p class="date"> 行业分类 </p>
                  <p class="time" @click.stop="showCondition('industry')">
                    <span v-if="isEmptyObj(conditions['industry']) && isEmptyObj(conditions['industrysecond'])">全部</span>
                    <template v-for="(type, obj) in pageshowConditions['industry']">
                      <template v-if="obj.length > 0 || type == 'S综合'">
                        <span class="text-b">{{type}}</span>
                        <template v-for="item in obj" v-if="obj.length !== industry">
                          {{item}}
                        </template>
                      </template>                   
                    </template>
                  </p>
                </li>
              </template>
            </ul>
          </div>
        </div>

        <!--1 筛选弹窗-公告类型-->
        <template v-if="showConditionFlag=='type'">
          <div aria-hidden="false" aria-labelledby="myModalLabel" role="dialog" tabindex="-1" id="dialog" class="modal fade in" style="display: block; ">
            <div class="toolsbar">
              <span class="cancle-btn" @click="showConditionFlag = ''"></span>
              <span class="menu-options">公告类型</span>
              <span class="menu-head-empty" @click="this.conditions['type'] = {}, select_type = []">清空</span>
              <span class="menu-head-Determine" @click="showConditionFlag = '', setSelectCondition('select_type', conditions['type'])">确定</span>
            </div>

            <div class="menu-cont">
              <ul class="one-row-box">
                <li v-for="type in types">
                  <a href="javascript:;" class="dio">
                    <label class="el-checkbox el-mar" @click.stop="addCondition('type', type)">
                    <span class="el-checkbox-input el-top" :class="{'is-checked': conditions['type'][type.code]}">
                      <span class="el-checkbox-inner"></span>
                    </span>
                      <span class="el-checkbox-label el-text">{{type.name}}</span>
                    </label>
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </template>
        <!--2 筛选弹窗-问题类型-->
        <template v-if="showConditionFlag=='qaType'">
          <div aria-hidden="false" aria-labelledby="myModalLabel" role="dialog" tabindex="-1" id="dialog" class="modal fade in" style="display: block; ">
            <div class="toolsbar">
              <span class="cancle-btn" @click="showConditionFlag = ''"></span>
              <span class="menu-options">问题类型</span>
              <span class="menu-head-empty" @click="this.conditions['qaType'] = {}, select_qaType = []">清空</span>
              <span class="menu-head-Determine" @click="showConditionFlag = '', setSelectCondition('select_qaType', conditions['qaType'])">确定</span>
            </div>

            <div class="menu-cont">
              <ul class="one-row-box">
                <li v-for="type in qaTypes">
                  <a href="javascript:;" class="dio">
                    <label class="el-checkbox el-mar" @click.stop="addCondition('qaType', type)">
                    <span class="el-checkbox-input el-top" :class="{'is-checked': conditions['qaType'][type.code]}">
                      <span class="el-checkbox-inner"></span>
                    </span>
                      <span class="el-checkbox-label el-text">{{type.name}}</span>
                    </label>
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </template>
        <!--3 筛选弹窗-板块类型-->
        <template v-if="showConditionFlag=='plate'">
          <div aria-hidden="false" aria-labelledby="myModalLabel" role="dialog" tabindex="-1" id="dialog" class="modal fade in" style="display: block; ">
            <div class="toolsbar">
              <span class="cancle-btn" @click="showConditionFlag = ''"></span>
              <span class="menu-options">板块类型</span>
              <span class="menu-head-empty" @click="clearPlate">清空</span>
              <span class="menu-head-Determine" @click="showConditionFlag = '', setSelectCondition('select_plate', conditions['plate'])">确定</span>
            </div>

            <div class="menu-cont">
              <ul class="one-row-box" v-show="!showChildFlag.plate">
                <li v-for="d in plates">
                  <a href="javascript:;" class="dio" v-if="d.child">
                    <label class="el-checkbox el-mar">
                    <span class="el-checkbox-input el-top" :class="{'is-checked': conditions['plate'][d.code]}" @click.stop="addCondition('plate', d)">
                      <span class="el-checkbox-inner"></span>
                    </span>
                      <span class="el-checkbox-label el-text" @click.stop="addCondition('plate', d)">
                      {{d.name}}
                      <template v-if="d.count > 0 && !conditions['plate']['N3BGP']" style="color:#3270ad;">
                        <span style="color:#1E88E5;" v-if="conditions['plate'] !== {}">({{ d.count }})</span>
                      </template>
                    </span>
                      <span class="qicon ques_5 mop close" @click.stop="slideToggleFilter(d.code, $event)"></span>
                    </label>
                    <template v-if="d.child">
                      <ul class="second" id="{{d.code}}" style="display: none;">
                        <li v-for="child in d.child">
                          <a href="javascript:;">
                            <label class="el-checkbox el-mar" @click.stop="addCondition('layer', child, d)">
                             <span class="el-checkbox-input el-top" :class="{'is-checked': conditions['layer'][child.code]}">
                              <span class="el-checkbox-inner"></span>
                             </span>
                              <span class="el-checkbox-label  el-text">{{child.name}}</span>
                            </label>
                          </a>
                        </li>
                      </ul>
                    </template>
                  </a>
                  <a href="javascript:;" class="dio" v-else>
                    <label class="el-checkbox el-mar" @click.stop="addCondition('plate', d)">
                    <span class="el-checkbox-input el-top" :class="{'is-checked': conditions['plate'][d.code]}">
                      <span class="el-checkbox-inner"></span>
                    </span>
                      <span class="el-checkbox-label el-text">{{d.name}}</span>
                    </label>
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </template>
        <!--4 筛选弹窗-地区类型-->
        <template v-if="showConditionFlag=='region'">
          <div aria-hidden="false" aria-labelledby="myModalLabel" role="dialog" tabindex="-1" id="dialog" class="modal fade in" style="display: block; ">
            <div class="toolsbar">
              <span class="cancle-btn" @click="showConditionFlag = ''"></span>
              <span class="menu-options">地区类型</span>
              <span class="menu-head-empty" @click="this.conditions['region'] = {}, select_region = []">清空</span>
              <span class="menu-head-Determine" @click="showConditionFlag = '', setSelectCondition('select_region', conditions['region'])">确定</span>
            </div>

            <div class="menu-cont">
              <ul class="one-row-box">
                <li v-for="d in regions">
                  <a href="javascript:;" class="dio">
                    <label class="el-checkbox el-mar" @click.stop="addCondition('region', d)">
                    <span class="el-checkbox-input el-top" :class="{'is-checked': conditions['region'][d.code]}">
                      <span class="el-checkbox-inner"></span>
                    </span>
                      <span class="el-checkbox-label el-text">{{d.name}}</span>
                    </label>
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </template>
        <!--5 筛选弹窗-主板券商-->
        <template v-if="showConditionFlag=='securityCompany'">
          <div aria-hidden="false" aria-labelledby="myModalLabel" role="dialog" tabindex="-1" id="dialog" class="modal fade in" style="display: block; ">
            <div class="toolsbar">
              <span class="cancle-btn" @click="showConditionFlag = ''"></span>
              <span class="menu-options">主板类型</span>
              <span class="menu-head-empty" @click="this.conditions['securityCompany'] = {}, select_securityCompany = []">清空</span>
              <span class="menu-head-Determine" @click="showConditionFlag = '', setSelectCondition('select_securityCompany', conditions['securityCompany'])">确定</span>
            </div>

            <div class="menu-cont">
              <ul class="one-row-box">
                <li v-for="d in securityCompany">
                  <a href="javascript:;" class="dio">
                    <label class="el-checkbox el-mar" @click.stop="addCondition('securityCompany', d)">
                      <span class="el-checkbox-input el-top" :class="{'is-checked': conditions['securityCompany'][d.code]}">
                        <span class="el-checkbox-inner"></span>
                      </span>
                      <span class="el-checkbox-label el-text">{{d.name}}</span>
                    </label>
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </template>
        <!--6 筛选弹窗-行业分类-->
        <template v-if="showConditionFlag=='industry'">
          <div aria-hidden="false" aria-labelledby="myModalLabel" role="dialog" tabindex="-1" id="dialog" class="modal fade in" style="display: block; ">
            <div class="toolsbar">
              <span class="cancle-btn" @click="showConditionFlag = ''"></span>
              <span class="menu-options">行业分类</span>
              <span class="menu-head-empty" @click="clearIndustry">清空</span>
              <span class="menu-head-Determine" @click="showConditionFlag = '', setSelectCondition('select_industry', conditions['industry'])">确定</span>
            </div>

            <div class="menu-cont">
              <ul class="one-row-box" v-show="!showChildFlag.industry">
                <li v-for="d in industry">
                  <a href="javascript:;" class="dio" v-if="d.child.length>0">
                    <label class="el-checkbox el-mar">
                    <span class="el-checkbox-input el-top" :class="{'is-checked': conditions['industry'][d.code]}" @click.stop="addCondition('industry', d)">
                      <span class="el-checkbox-inner"></span>
                    </span>
                    <span class="el-checkbox-label el-text" @click.stop="addCondition('industry', d)">
                      {{d.code}} {{d.name}}
                      <template v-if="d.count > 0 && !conditions['industry'][d.code]">
                        <span style="color:#1E88E5;">({{d.count}})</span>
                      </template>
                    </span>
                      <span class="qicon ques_5 mop close" @click.stop="slideToggleFilter(d.id, $event)"></span>
                    </label>
                    <template v-if="d.child.length>0">
                      <ul class="second" id="{{d.id}}" style="display: none;">
                        <li v-for="child in d.child">
                          <a href="javascript:;">
                            <label class="el-checkbox el-mar" @click.stop="addCondition('industrysecond', child, d)">
                            <span class="el-checkbox-input el-top" :class="{'is-checked': conditions['industrysecond'][child.code]}">
                              <span class="el-checkbox-inner"></span>
                            </span>
                              <span class="el-checkbox-label  el-text">{{child.code}} {{child.name | maxlen 10}}</span>
                            </label>
                          </a>
                        </li>
                      </ul>
                    </template>
                  </a>
                  <a href="javascript:;" class="dio" v-else="d.child">
                    <label class="el-checkbox el-mar" @click.stop="addCondition('industry', d)">
                    <span class="el-checkbox-input el-top" :class="{'is-checked': conditions['industry'][d.code]}">
                      <span class="el-checkbox-inner"></span>
                    </span>
                      <span class="el-checkbox-label el-text">{{d.code}} {{d.name}}</span>
                    </label>
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </template>
      </div>

      <!--搜索结果-->
      <div class="my-container" v-show="showComments" style="top: 0px;position:static;background-color:white;">
        <div class="comment-detail">
          <div class="comment-title">
           <p class="comment-all">全部评论</p> <!-- <a class="comment-my" href="javascript:;">我的评论</a>  -->
           <p class="comment-sort">{{cpwtotal}}条评论</p>
          </div>
          <div class="comment" v-for="item in commentList">
            <div class="common-avatar">
            <img src="/static/images/user.png" width="100%" height="100%">

          </div>
          <div class="comment-block">
            <p class="comment-user">
              <span class="comment-username" v-if="item.user"> {{item.user.username}} </span>
              <span class="comment-username" v-else> 匿名用户 </span>
            <span class="footer-zan"> <i class="c-share-icon" @click.stop="zan(item.id, $event)"></i><span class="u-num">{{item.zan_cnt}}</span></span>
            </p>
             <div class="comment-content">{{item.content}}
             </div>
             <div class="comment-operate">
                <span class="J_Vote comment-operate-item comment-operate-up">{{item.updtime | date}}</span>
                <span class="J_Reply comment-operate-item"> <a href="javascript:;" @click="commentinput = true, pid = item.id, content = ''">回复</a> </span>
            </div>
            <div class="comment-reply-ctn comment-reply-item" >
              <ul>
                <li v-for="i in item.replys" track-by="$index" v-if="$index < item.showall">
                  <p class="comment-text">
                    <span class="c-username" v-if="i.user"> {{i.user.username}} </span>
                    <span class="c-username" v-else>匿名用户</span>
                    {{i.content}}
                  </p>
                  <div class="reply-operate reply-operate-hot">
                      <span class="J_Vote reply-operate-item reply-up"><i class="c-share-icon" @click.stop="zan(i.id, $event)"></i><span>{{i.zan_cnt}}</span></span>
                        <span class="J_Reply reply-operate-item"></span>  <span>{{i.updtime | date}}</span>
                    </div>
                </li>
                <!-- <li v-for="y in item.replys" track-by="$index" v-if="showall">
                  <p class="comment-text">
                    <span class="c-username" v-if="y.user"> {{y.user.username}} </span>
                    <span class="c-username" v-else>匿名用户</span>
                    {{y.content}}
                  </p>
                  <div class="reply-operate reply-operate-hot">
                      <span class="J_Vote reply-operate-item reply-up">赞<i class="staticAdd" @click.stop="zan(i.id, $event)">{{i.zan_cnt}}</i></span>
                        <span class="J_Reply reply-operate-item"></span>  <span>{{y.updtime | date}}</span>
                    </div>
                </li> -->

                <li class="view-more hidden" v-if="item.replys.length > 2 && item.showall !== 8">
                  <a class="btn-block text-center btn-comment-expand" @click="item.showall = 8">查看全部<span class="nume">{{item.replys.length}}</span>条回复  </a>
                </li>
              </ul>
              </div>
          </div>
          </div>
          </div>

          <div class="comment-more">
          <a href="javascript:;" v-if="commentList.length !== cpwtotal">加载更多评论中...</a>
          <a href="javascript:;" v-if="commentList.length == cpwtotal && cpwtotal !== 0">评论已全部加载</a>
          </div>
          <div class="comment-no" v-if="cpwtotal == 0">
          暂无评论，快来添加一个吧！
          </div>
          <div class="comment-no"></div>
        </div>
      <div class="result-container" id="result-container" v-if="showResultPage && !showSearchPage && !showTongjiPage && !showComments">
        <template v-if="topPage === 1">

            <!-- 1、搜索结果头部 -->
          <div class="search-header">
            <div class="search-header-text">
              <!--A股·大数据-->
              <span v-if="stype != 13">{{stype | formatTypeName}}</span>
              <span v-if="stype == 13">研报数据</span>
              <span>·</span>
              <span>{{keywords | formatKeywords}}</span>
            </div>
            <span class="search-header-stics" @click="switchPage(3), showStatAnalyze = true, setCnzz('[Mobile]-信披搜索', '进入统计页', '')">统计</span>
            <span class="search-header-stics" @click="showModalTag = true">保存标签</span>
          </div>
            <!-- 2、搜索结果日期及相关排序 -->
          <div class="screen-menu">
            <div class="release-date">
              <div @click.stop="slideToggle('date')">
                {{ datetype_name }}
                <span class="close-bot"></span>
              </div>
              <div class="slide-menu" v-show="showDropdownMenu == 'date'">
                <ul class="date-menu" @click="hideDropdown(), setCnzz('[Mobile]-信披搜索', '点击日期筛选下拉框', '')">
                  <li @click="sortByDate(1)">一个月</li>
                  <li @click="sortByDate(2)">一个季度</li>
                  <li @click="sortByDate(3)">半年</li>
                  <li @click="sortByDate(4)">去年</a></li>
                  <li @click="sortByDate(5)">今年</li>
                  <li @click="sortByDate(6)">一年</li>
                  <li @click="sortByDate(7)">两年</li>
                  <li @click="sortByDate(8)">三年</li>
                  <li @click="sortByDate(9)">五年</li>
                  <li @click="sortByDate(10)">十年</li>
                  <li @click="sortByDate(98)">全部</li>
                  <li @click="sortByDate(99)">自定义</li>
                </ul>
              </div>
            </div>
            <span class="release-line"></span>
            <div class="release-date">
              <div @click.stop="slideToggle('sort')">
                {{ sort==1?'按相关性排序':'按时间排序' }}
                <span class="close-bot"></span>
              </div>
              <ul class="date-menu" v-show="showDropdownMenu == 'sort'" @click="hideDropdown">
                <li><a href="javascript:;" @click="selSort(1), setCnzz('[Mobile]-信披搜索', '点击按相关性排序按钮', '')">按相关性排序</a></li>
                <li><a href="javascript:;" @click="selSort(2),  setCnzz('[Mobile]-信披搜索', '点击按时间排序按钮', '')">按时间排序</a></li>
              </ul>
            </div>
          </div>

          <!--3、自定义筛选时间-->
          <div class="search-date-custom" v-show="datetype_name !== '全部'">
            <p class="time">
              <span class="l">
                  <date-picker :time.sync="startdate" :option="datepicker.option" :datetype.sync="datetype"></date-picker>
              </span>~
              <span class="r">
                 <date-picker :time.sync="enddate" :option="datepicker.option" :datetype.sync="datetype"></date-picker>
              </span>
            </p>
          </div>

          <!--我的标签-->
          <div class="Screen-criteria" v-if="tagLists.length > 0">
            <div class="Screen-criteria-head" @click="showtag = !showtag, slideToggleTag()">
              <span class="fl">我的标签</span>
              <span class="fr" v-if="showtag"></span>
              <span class="f3" v-if="!showtag"></span>
            </div>
            <div class="Screen-criteria-box cpwtag" style="display:none;">
              <ul>
                <li v-for="item in tagLists" @click="searchByTag(item.id), showtag = false, slideToggleTag()">
                  <span class="notice-left">{{item.name}}</span>
                  <span class="notice-right" @click.stop="delTag(item.id)"></span>
                </li>
              </ul>
            </div>
          </div>

          <!--4、返回搜索条件-->
          <div class="search-criteria" @click="switchPage(1), setCnzz('[Mobile]-信披搜索', '查看搜索条件', '')">
            <span class="fl">搜索条件</span>
            <span class="fr"></span>
          </div>

          <!--筛选条件-->
          <template v-if="havelabels">
            <div class="Screen-criteria">
              <div class="Screen-criteria-head" @click.stop="slideDropdownMenu($event)">
                <span class="fl">筛选条件</span>
                <span class="f3 close"></span>
              </div>
              <div class="Screen-criteria-box sxtj" style="display: none;">
                <ul>
                  <template v-for="(type, obj) in conditions">
                    <!--类型-title-->
                    <li v-if="!isEmptyObj(obj) && type !== 'industry' && type !== 'industrysecond' && type !=='layer' && type !== 'plate'">
                      <span class="selected-icon"></span>
                      <a class="blue">{{ cond_type[type] }}</a>
                    </li>
                    <!--text-->
                    <template v-for="(code, name) in obj" v-if="type !== 'industry' && type !== 'industrysecond' && type !=='layer' && type !== 'plate'">
                      <li>
                        <span class="notice-left">{{ name }} </span>
                        <span aria-hidden="true" class="notice-right" @click="rmvCondition(type, code), this.setCnzz('[Mobile]-信披搜索', '删除指定筛选条件', '')"></span>
                      </li>
                    </template>
                  </template>

                  <!--1 板块类型-->
                  <li v-if="showPla">
                    <span class="selected-icon"></span>
                    <a class="blue">{{cond_type['plate']}}</a>
                  </li>
                  <!--no guapai-->
                  <li v-for="(idx, item) in pageshowConditions['plate']" v-if="idx !== '挂牌公司' && item">
                    <span class="notice-left">{{item}}</span>
                    <span aria-hidden="true" class="notice-right" @click="rmvCondition('plate', idx), this.setCnzz('[Mobile]-信披搜索', '删除指定筛选条件', '')"></span>
                  </li>
                  <!--挂牌公司-->
                  <li class="active" v-if="pageshowConditions['plate']['挂牌公司'].length > 0">
                    <span class="selected-icon"></span>
                    <span class="notice-left">挂牌公司</span>
                    <span aria-hidden="true" class="notice-right" @click="rmvCondition('N3BGP', 'N3BGP'), this.setCnzz('[Mobile]-信披搜索', '删除指定筛选条件', '')"></span>
                  </li>
                  <li v-for="i in pageshowConditions['plate']['挂牌公司']" v-if="pageshowConditions['plate']['挂牌公司'].length > 0">
                    <span class="notice-left">{{i}}</span>
                    <span aria-hidden="true" class="notice-right" @click="rmvCondition('layer', i), this.setCnzz('[Mobile]-信披搜索', '删除指定筛选条件', '')"></span>
                  </li>

                  <!--2 行业分类-->
                  <li v-if="showInd">
                    <span class="selected-icon"></span>
                    <a class="blue">{{cond_type['industry']}}</a>
                  </li>
                  <template v-for="(type, obj) in pageshowConditions['industry']">
                    <template v-if="obj.length > 0 || type == 'S综合'">
                      <li class="active">
                        <span class="selected-icon"></span>
                        <span class="notice-left">{{type}}</span>
                        <span class="notice-right" @click="rmvCondition('industry', type.substr(0,1)), this.setCnzz('[Mobile]-信披搜索', '删除指定筛选条件', '')"></span>
                      </li>
                      <li v-for="item in obj" v-if="obj.length !== industry">
                        <span class="notice-left">{{item}}</span>
                        <span class="notice-right" @click="rmvCondition('industrysecond', item.substr(0, 3)), this.setCnzz('[Mobile]-信披搜索', '删除指定筛选条件', '')"></span>
                      </li>
                    </template>
                  </template>
                </ul>
              </div>
            </div>
          </template>

          <!--智能引擎-->
          <div class="intelligent-search-main">
            <div class="intelligent-search" v-if="smartComInfo.shortname && smartComInfo.code">
              
              <div class="intelligent-heading" style="cursor:pointer;">
                <span class="big-h" @click="goCompanyInfo(smartComInfo.code)">{{smartComInfo.shortname}}【{{smartComInfo.code}}】</span>
              </div>
              <div class="op-stockdynamic" v-if="smartComInfo.price">
                <div class="op-stockdynamic-top" :class="{'plus': upanddown.indexOf('+') === 0, 'reduce': upanddown.indexOf('-') === 0}">
                  <span class="op-cur-num">{{prices.trade}}元</span>
                  <span class="op-cur-info">{{upanddown}}({{Amplitude}}%)</span>
                </div>
                <div class="op-stockdynamic-bot">
                  <ul>
                    <!-- <li>今日开盘：{{prices.open}}元  今日最高：{{prices.high}}元</li>
                    <li>昨日收盘：{{prices.yesclose}}元  今日最低：{{prices.low}}元</li>
                    <li>今日成交量：<template v-if="prices.volume < 100000">{{prices.volume}}手</template>
                      <template v-if="prices.volume > 100000 || prices.volume == 100000">{{(prices.volume/ 10000).toFixed(1)}}万手</template>
                    </li> -->
                     <ul class="op-clear">
                      <li>昨收：{{prices.settlement}}</li>
                      <li>今开：{{prices.open}}</li>
                      <li>最高：{{prices.high}}</li>
                      <li>最低：{{prices.low}}</li>
                    </ul>
                    <ul class="op-clear">
                      <li>成交量：<template v-if="prices.volume < 10000000">{{prices.volume}}手</template>
                          <template v-if="prices.volume > 10000000 || prices.volume == 10000000">{{(prices.volume/ 1000000).toFixed(2) | thousands}}万手</template></li>
                      <li>成交额：{{(prices.amount/ 100000000).toFixed(2) | thousands}}亿</li>
                      <li>总市值：{{(prices.mktcap/10000).toFixed(2) | thousands}}亿</li>
                      <li>流通市值：{{(prices.nmc/10000).toFixed(2) | thousands}}亿</li>
                    </ul>
                    <ul class="op-clear">
                      <li>换手率：{{prices.turnoverratio.toFixed(2)}}%</li>
                      <li>市净率：{{prices.pb.toFixed(2)}}</li>
                      <li>振  幅：{{prices.changepercent.toFixed(2)}}%</li>
                      <li>市盈率：{{prices.per.toFixed(2)}}</li>
                    </ul>
                  </ul>
                </div>
              </div>
            </div>
            <div class="intelligent-search" v-if="smartComInfo.finance && smartComInfo.finance.length > 0">
              <div class="intelligent-heading">
                {{smartComInfo.shortname}}【{{smartComInfo.code}}】财务信息
              </div>
              <div class="table-result-outter">
                <ul class="personnel">
                  <li :class="{'active': timetyp === 1}" @click="timetyp = 1">按季度</li>
                  <li :class="{'active': timetyp === 2}" @click="timetyp = 2">按年度</li>
                </ul>
                <div style="margin-bottom: 20px;">
                  <table class="table-result" cellpadding="0">
                    <tbody v-if="timetyp === 1">
                    <tr class="title">
                      <!-- <td v-for="i in finance[0]">{{i}}</td> -->
                      <!-- <td>日期</td> -->
                      <td>按报告期</td>
                      <td>{{smartComInfo.financeCols[0].name}}（{{smartComInfo.financeCols[0].unit}}）</td>
                    </tr>
                    <tr v-if="$index > 0 && $index < 6" v-for="item in finance" track-by="$index" :class="{'evencom': $index % 2 > 0, 'oldcom': $index % 2 === 0 }">
                      <td v-for="(k,i) in item">
                        <template v-if="k === 0">{{i}}</template>
                        <!-- <template v-if="k !== 0">{{i['营业收入'] | thousands}}</template> -->
                        <template v-if="k !== 0">{{i[smartComInfo.financeCols[0].name] | thousands}}</template>
                      </td>
                    </tr>
                    </tbody>
                    <tbody v-if="timetyp === 2">
                    <tr class="title">
                      <!-- <td v-for="i in yearfinance[0]">{{i}}</td> -->
                       <!-- <td>日期</td> -->
                       <td>按报告期</td>
                      <td>{{smartComInfo.financeCols[0].name}}（{{smartComInfo.financeCols[0].unit}}）</td>
                    </tr>
                    <tr v-if="$index > 0 && $index < 6" v-for="item in yearfinance" track-by="$index" :class="{'evencom': $index % 2 > 0, 'oldcom': $index % 2 === 0 }">
                      <td v-for="(k,i) in item">
                        <template v-if="k === 0">{{i}}</template>
                        <!-- <template v-if="k !== 0">{{i['营业收入'] | thousands}}</template> -->
                        <template v-if="k !== 0">{{i[smartComInfo.financeCols[0].name] | thousands}}</template>
                      </td>
                    </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </template>
        <!-- 综合搜索 -->
        <div v-if="stype == 100" style="margin-bottom:25px">  
          <!-- 新闻 -->
          <div class="index-colligate-main" v-if="complex_hk">
            <div class="index_box">
              <div class="intelligent-search-notice">
                <div class="intelligent-heading" style="width:100%;border-left:none;background:#fff;padding:0 -2px;height:33px;line-height:33px">
                <span class="jddAul" style="display:inline-block;color:black;font-weight:bold">新闻</span>
                <div class="indicator-filter" style="display:inline-block;float:right;margin-right:20px;font-size:12px">
                    <span class="count-wrapper">共有<span class="blue" style="cursor:pointer">{{stypesTotal['12']}}</span>条搜索结果</span>
                </div>
                </div>
                <div class="intelligent-list">
                  <resfrag :currentuser="currentuser" :stype="12" :items="complex_news" :onlytitle="parseInt(onlyTitle)"></resfrag>
                  <div class="compre-more">
                    <a href="javascript:;" @click="stype = 12,searchMore(12)">查看更多</a>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- 知识库 -->
          <div class="index-colligate-main" v-if="complex_knowledge">
            <div class="index_box">
              <div class="intelligent-search-notice">
                <div class="intelligent-heading" style="width:100%;border-left:none;background:#fff;padding:0 -2px;height:33px;line-height:33px">
                <span class="jddAul" style="display:inline-block;color:black;font-weight:bold">知识库</span>
                <div class="indicator-filter" style="display:inline-block;float:right;margin-right:20px;font-size:12px">
                    <span class="count-wrapper">共有<span class="blue" style="cursor:pointer">{{stypesTotal['4']}}</span>条搜索结果</span>
                  </div>
                </div>
                <div class="intelligent-list">
                  <resfrag :currentuser="currentuser" :stype="4" :items="complex_knowledge" :onlytitle="parseInt(onlyTitle)"></resfrag>
                  <div class="compre-more">
                    <a href="javascript:;" @click="stype = 4,searchMore(4)">查看更多</a>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- 研报数据 -->
          <div class="index-colligate-main" v-if="complex_reportdata">
            <div class="index_box">
              <div class="intelligent-search-notice">
                <div class="intelligent-heading" style="width:100%;border-left:none;background:#fff;padding:0 -2px;height:33px;line-height:33px">
                <span class="jddAul" style="display:inline-block;color:black;font-weight:bold">研报数据</span>
                <div class="indicator-filter" style="display:inline-block;float:right;margin-right:20px;font-size:12px">
                    <span class="count-wrapper">共有<span class="blue" style="cursor:pointer">{{stypesTotal['13']}}</span>条搜索结果</span>
                  </div>
                </div>
                <div class="intelligent-list">
                  <resfrag :currentuser="currentuser" :stype="13" :items="complex_reportdata" :onlytitle="parseInt(onlyTitle)"></resfrag>
                  <div class="compre-more">
                    <a href="javascript:;" @click="stype = 13,searchMore(13)">查看更多</a>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- 研报 -->
          <div class="index-colligate-main" v-if="complex_yb">
            <div class="index_box">
              <div class="intelligent-search-notice">
                <div class="intelligent-heading" style="width:100%;border-left:none;background:#fff;padding:0 -2px;height:33px;line-height:33px">
                <span class="jddAul" style="display:inline-block;color:black;font-weight:bold">研报</span>
                <div class="indicator-filter" style="display:inline-block;float:right;margin-right:20px;font-size:12px">
                    <span class="count-wrapper">共有<span class="blue" style="cursor:pointer">{{stypesTotal['11']}}</span>条搜索结果</span>
                  </div>
                </div>
                <div class="intelligent-list">
                  <resfrag :currentuser="currentuser" :stype="11" :items="complex_yb" :onlytitle="parseInt(onlyTitle)"></resfrag>
                  <div class="compre-more">
                    <a href="javascript:;" @click="stype = 11,searchMore(11)">查看更多</a>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!--   A股 -->
          <div class="index-colligate-main" v-if="complex_agu">
            <div class="index_box">
              <div class="intelligent-search-notice">
                <div class="intelligent-heading" style="width:100%;border-left:none;background:#fff;padding:0 -2px;height:33px;line-height:33px">
                <span class="jddAul" style="display:inline-block;color:black;font-weight:bold">A股</span>
                <div class="indicator-filter" style="display:inline-block;float:right;margin-right:20px;font-size:12px">
                    <span class="count-wrapper">共有<span class="blue" style="cursor:pointer">{{stypesTotal['1']}}</span>条搜索结果</span>
                  </div>
                </div>
                <div class="intelligent-list">
                  <resfrag :currentuser="currentuser" :stype="1" :items="complex_agu" :onlytitle="parseInt(onlyTitle)"></resfrag>
                  <div class="compre-more">
                    <a href="javascript:;" @click="stype = 1,searchMore(1)">查看更多</a>
                  </div>
                </div>
              </div>
            </div>
          </div>
         
          <!-- 新三板 -->
          <div class="index-colligate-main" v-if="complex_n3b">
            <div class="index_box">
              <div class="intelligent-search-notice">
                <div class="intelligent-heading" style="width:100%;border-left:none;background:#fff;padding:0 -2px;height:33px;line-height:33px">
                <span class="jddAul" style="display:inline-block;color:black;font-weight:bold">新三板</span>
                <div class="indicator-filter" style="display:inline-block;float:right;margin-right:20px;font-size:12px">
                    <span class="count-wrapper">共有<span class="blue" style="cursor:pointer">{{stypesTotal['2']}}</span>条搜索结果</span>
                  </div>
                </div>
                <div class="intelligent-list">
                  <resfrag :currentuser="currentuser" :stype="2" :items="complex_n3b" :onlytitle="parseInt(onlyTitle)"></resfrag>
                  <div class="compre-more">
                    <a href="javascript:;" @click="stype = 2,searchMore(2)">查看更多</a>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- 问题库 -->
          <div class="index-colligate-main" v-if="complex_qa">
            <div class="index_box">
              <div class="intelligent-search-notice">
                <div class="intelligent-heading" style="width:100%;border-left:none;background:#fff;padding:0 -2px;height:33px;line-height:33px">
                <span class="jddAul" style="display:inline-block;color:black;font-weight:bold">问题库</span>
                <div class="indicator-filter" style="display:inline-block;float:right;margin-right:20px;font-size:12px">
                    <span class="count-wrapper">共有<span class="blue" style="cursor:pointer">{{stypesTotal['5']}}</span>条搜索结果</span>
                  </div>
                </div>
                <div class="intelligent-list">
                  <resfrag :currentuser="currentuser" :stype="5" :items="complex_qa" :onlytitle="parseInt(onlyTitle)"></resfrag>
                  <div class="compre-more">
                    <a href="javascript:;" @click="stype = 5,searchMore(5)">查看更多</a>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- 港股 -->
          <div class="index-colligate-main" v-if="complex_hk">
            <div class="index_box">
              <div class="intelligent-search-notice">
                <div class="intelligent-heading" style="width:100%;border-left:none;background:#fff;padding:0 -2px;height:33px;line-height:33px">
                <span class="jddAul" style="display:inline-block;color:black;font-weight:bold">港股</span>
                <div class="indicator-filter" style="display:inline-block;float:right;margin-right:20px;font-size:12px">
                    <span class="count-wrapper">共有<span class="blue" style="cursor:pointer">{{stypesTotal['6']}}</span>条搜索结果</span>
                  </div>
                </div>
                <div class="intelligent-list">
                  <resfrag :currentuser="currentuser" :stype="6" :items="complex_hk" :onlytitle="parseInt(onlyTitle)"></resfrag>
                  <div class="compre-more">
                    <a href="javascript:;" @click="stype = 6,searchMore(6)">查看更多</a>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- 债券 -->
          <div class="index-colligate-main" v-if="complex_bond">
            <div class="index_box">
              <div class="intelligent-search-notice">
                <div class="intelligent-heading" style="width:100%;border-left:none;background:#fff;padding:0 -2px;height:33px;line-height:33px">
                <span class="jddAul" style="display:inline-block;color:black;font-weight:bold">债券</span>
                <div class="indicator-filter" style="display:inline-block;float:right;margin-right:20px;font-size:12px">
                    <span class="count-wrapper">共有<span class="blue" style="cursor:pointer">{{stypesTotal['3']}}</span>条搜索结果</span>
                  </div>
                </div>
                <div class="intelligent-list">
                  <resfrag :currentuser="currentuser" :stype="3" :items="complex_bond" :onlytitle="parseInt(onlyTitle)"></resfrag>
                  <div class="compre-more">
                    <a href="javascript:;" @click="stype = 3,searchMore(3)">查看更多</a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- 研报 -->
        <div v-if="stype == 13" class="report-data">
          <div class="index-colligate-main" style="margin-bottom:45px;">
            <div class="index_box">
              <div class="intelligent-search-notice">
                <div class="intelligent-heading" style="width:100%;border-left:none;background:#fff;padding:0 -2px;height:33px;line-height:33px">
                <span class="jddAul" style="display:inline-block;color:black;font-weight:bold">研报数据</span>
                <div class="indicator-filter" style="display:inline-block;float:right;margin-right:20px;font-size:12px">
                    <span class="count-wrapper">共有<span class="blue" style="cursor:pointer">{{reportDataTotal}}</span>条搜索结果</span>
                  </div>
                </div>
                <div class="intelligent-list">
                  <resfrag :currentuser="currentuser" :stype="13" :items="reportDataList" :onlytitle="parseInt(onlyTitle)"></resfrag>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-if="stype == 17" class="report-data">
          <div class="index-colligate-main" >
            <div class="index_box">
              <div class="intelligent-search-notice">
                <div class="intelligent-heading" style="width:100%;border-left:none;background:#fff;padding:0 -2px;height:33px;line-height:33px">
                <span class="jddAul" style="display:inline-block;color:black;font-weight:bold">English</span>
                <div class="indicator-filter" style="display:inline-block;float:right;margin-right:20px;font-size:12px">
                    <span class="count-wrapper">共有<span class="blue" style="cursor:pointer">{{reportDataTotal}}</span>条搜索结果</span>
                  </div>
                </div>
                <div class="intelligent-list">
                  <resfrag :currentuser="currentuser" :stype="13" :items="reportDataList" :onlytitle="parseInt(onlyTitle)"></resfrag>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!--5、搜索结果-->
        <div class="search-result-box">
          <!-- 无数据 -->
          <div class="anwer-cont"  v-show="searched==stype && items.length==0">
            <div class="no">很抱歉，没有找到相关的结果!</div>
          </div>
          <!-- 重新切换 -->
          <!-- <div class="anwer-cont"  v-show="searched!=stype && !loading">
            <div class="no">切换板块请重新搜索 </div>
          </div> -->
          <!-- 加载中 -->
          <div class="more_top" v-show="!loading && topPage !== 1 && total !== 0" style="margin-bottom: -0.4rem;">
            <i class="pull_icon_top loading"></i>
            <span style="font-size: 15px;">加载中...</span>
          </div>

          <div v-show="searched==stype && detailLists.length>0" id="my-result-wrap" style="margin-bottom:5px">
            <template v-if="stype!=5">
              <div class="search-result-list" v-for="item in detailLists" track-by="$index">
                <p class="head">
                  <span class="{{ fileIcon(item.fileext) }}"></span>
                  <!-- 未登录状态下 -->
                  <a v-if="stype!=5&&stype != 10" style="cursor:pointer;"  @click="checkLogin(item), setCnzz('[Mobile]-信披搜索', '查看公告详情', '')" class="green">{{{ item.fulltitle }}}</a>
                  <a v-if="stype == 10" style="cursor:pointer;"  @click="openAbsAnn(item), setCnzz('[Mobile]-信披搜索页', '查看公告详情', '')" class="green">{{{ item.fulltitle }}}</a>
                  <!-- 跳转详情页面 -->
                  <a v-if="stype==5" style="cursor:pointer;" @click="checkLoginQa(item), setCnzz('[Mobile]-信披搜索', '查看公告详情', '')" class="green">{{{ item.fulltitle }}}</a>
                </p>
                <p class="Subtitle">
                  {{ item.publishDate ? item.publishDate: item.uploadTime }}
                  <span class="marginlf-10">{{ item.companyCode }}</span>
                  <span class="marginlf-10" v-if="item.author">作者: {{ item.author }}</span>
                  <span class="marginlf-10" v-if="item.nickname">公众号: {{ item.nickname }}</span>
                </p>
                <p class="lien" v-if="item.content && item.content!='NoContent' && onlyTitle == 0">
                  {{{ item.content.join('...... ') }}}
                </p>
                <template v-if="item.child && onlyTitle == 0">
                  <template v-for="child in item.child">
                    <!-- <p class="blak font-weight lien" :style="indentChild(child.code)">{{{ child.title }}}</p> -->
                    <p class="blak font-weight lien child-title" :style="indentChild(child.code)" @click="viewChildTitle(item, child.code)" style="cursor:pointer;">
                      {{{ child.title }}}
                    </p>
                    <p class="lien" :style="indentChild(child.code)" v-if="child.content">
                      {{{ child.content.join('...... ') }}}
                    </p>
                    <template v-if="child.contents">
                      <template v-for="c in child.contents">
                        <p class="lien" :style="indentChild(child.code)" v-if="c.htmltag=='p'">
                          {{{ c.content }}}</br>
                        </p>
                        <template  v-if="c.htmltag=='table'">
                          <div class="table-result-outter">
                            <table cellpadding="0" class="table-result">
                              <tbody>
                              <tr v-for="(rowidx, row) in c.table" track-by="$index" :class="{'oldcom': !(rowidx%2), 'evencom': rowidx%2}">
                                <td v-for="(colidx, col) in row" rowspan="{{ col.row }}" colspan="{{ col.col }}" track-by="$index"> {{{col.value}}} </td>
                              </tr>
                              </tbody>
                            </table>
                          </div>
                          <div class="table-whole">
                            <a href="javascript:;" @click="viewTable(item, child.code, c.offset), setCnzz('[Mobile]-信披搜索', '查看表格全部内容', '')">
                              <span class="table-see-icon "></span>查看表格全部内容
                            </a>
                          </div>
                        </template>
                      </template>
                    </template>

                    <!-- 研报图表 -->
                    <div class="intelligent-fsearch-cont" v-if="child.imgs">
                      <template  v-for="c in child.imgs">
                        <div class="fsearch-a">

                          <div class="more-img" style="cursor:pointer;" title="点击查看更多" @click="setBigImgObj(c, item)">
                            <img :src="c.imgurl">
                          </div>
                          <div class="text-a">{{{child.title}}}</div>
                          <div class="text-b" style="cursor:pointer" @click="viewImg(item, child.code, c.offset)">{{{c.imghead}}}</div>
                          <div class="text-b" style="cursor:pointer" @click="viewImg(item, child.code, c.offset)">{{{c.imgfoot}}}</div>
                        </div>
                      </template>
                    </div><!-- /研报图表 -->
                  </template>
                </template>
              </div>
            </template>
              <!-- v-if stype = 5 -->
            <template v-if="stype==5">
              <div class="search-result-list" v-for="item in detailLists" track-by="$index">
                <p class="head">
                  <a class="green" style="cursor:pointer;" @click="checkLoginQa(item), setCnzz('[Mobile]-信披搜索', '查看表格全部内容', '')">{{{ item.fulltitle }}}</a>
                </p>
                <p class="Subtitle">{{ item.publishDate ? item.publishDate: item.uploadTime }}</p>
                <p class="lien" v-if="item.content && item.content!='NoContent'">{{{ item.content.join('...... ') }}}</p>
                <template v-if="item.child">
                  <template v-for="child in item.child" >
                    <div v-if="child.content" class="rb odd res-qa-title-wrap" style="overflow: hidden">
                      <p class="blak font-weight lien" >{{{ child.title }}}</p>
                      <p class="lien" v-if="child.content">
                        {{{ child.content.join('...... ') }}}
                      </p>
                    </div>
                    <div v-if="child.que" class="rb odd res-qa-middle-wrap">
                      <div class="res-qa-item-l">
                        <div class="ques-l"><span class="qicon ques_1" style="margin: 0.1rem 5px 2px 0px;"></span></div>
                      </div>
                      <div class="res-qa-item-r" style="width: 91%;">
                        <p class="lien" v-if="!child.showque">
                          {{{ child.shortque?child.shortque:child.que | maxlen 100 }}}
                          <span class="qust-more blue" @click="child.showque=true" v-if="child.que.length>100"> 展开更多<span class="triangle-bottom"></span></span>
                        </p>
                        <p class="lien" v-if="child.showque">
                          {{{ child.que }}}
                          <span class="qust-stop red" @click="child.showque=false"> 收起<span class="triangle-head"></span></span>
                        </p>
                        <div class="quest-blue">
                          <li v-for="t in child.tag"><a href="javascript:;">{{ t }}</a></li>
                        </div>
                      </div>
                    </div>
                    <div v-if="child.answers" v-for="ans in child.answers" class="res-qa-ans-wrap">
                      <div class="res-qa-item-l">
                        <div class="ques-l">
                          <span class="qicon ques_2" style="margin: 0.12rem 5px 2px 0px;"></span>
                        </div>
                      </div>
                      <div class="res-qa-item-r" style="width: 91%;">
                        <p class="quest-p">
                          <span class="font-weight" v-if="trim(ans.rername) !== ''">【{{ ans.rertitle }}: {{ ans.rername }}】</span>
                          <span class="ques-lt" v-if="!ans.showans"> {{{ ans.shortans?ans.shortans:ans.ans | maxlen 100 }}}</span>
                          <span class="ques-lt" v-show="ans.showans"> {{{ ans.ans }}}</span>
                          <span class="qust-more blue" v-if="!ans.showans && ans.ans.length>100" @click="ans.showans=true"> 展开更多<span class="triangle-bottom"></span> </span>
                          <span class="qust-stop red" v-if="ans.showans" @click="ans.showans=false"> 收起<span class="triangle-head"></span></span>
                        </p>
                      </div>
                    </div>
                  </template>
                </template>
              </div>
            </template>
          </div>

          <!--加载动画-->
          <div class="more" v-show="!loading && bottomPage < totalPage && total !== 0 && searched === stype" style="margin-bottom: 2rem;">
            <i class="pull_icon loading"></i>
            <span style="font-size: 15px;">加载中...</span>
          </div>
          <div class="more" v-show="bottomPage >= totalPage && total !== 0 && searched === stype && bottomTip" style="margin-bottom: 2rem;">
            <span style="font-size: 15px;">已加载全部内容</span>
          </div>
        </div><!-- /. 搜索结果 -->
      </div><!-- / 统计 -->
    </div>
    <!-- /.wrapper -->

    <!--微信绑定弹框-->
    <div aria-hidden="false" aria-labelledby="myModalLabel" role="dialog" tabindex="-1" id="dialog" class="modal fade in" v-show="tipGoBind">
      <div class="binding-content">
        <a class="binding-logo"></a>
        <div class="binding-text">
          立即绑定IBDATA账号<br/>成为金融分析高手
        </div>
        <div class="binding-bot">
          <a class="binding-no-btn" @click="tipGoBind = false">暂不绑定</a>
          <a class="binding-btn" @click="goBindPage">立即绑定</a>
        </div>
      </div>
    </div>
    <!-- 阴影 -->
    <div class="modal-backdrop fade in" v-show="tipGoBind"></div>

    <!--保存标签-->
    <div aria-hidden="false" aria-labelledby="myModalLabel" role="dialog" tabindex="-1" id="dialog" class="modal fade in" style="display: block;" v-if="showModalTag">
      <div class="comment-content-tag">  
         <div class="login-close" @click="showModalTag = false">
           <a class="delete-icon"></a> 
        </div>
          <div class="comment-reply"> 
           <input class="input-search-c"  type="text" placeholder="输入标签名称" v-model="tagname">
           <a class="btn-Publish" @click="saveTag()">确定</a>
          </div>  
      </div>
    </div>
    <div class="modal-backdrop fade in" v-if="showModalTag"></div>
    <!-- / 微信绑定弹框-->

    <!--公司详情-->
    <div class="wrapper" v-show="smartEngine.open">
      <div class="company-details-title">
        <span class="cancle-btn" @click.stop="smartEngine.open = false, setCnzz('[Mobile]信披搜索', '收起公司详情', '')"></span>
        <span class="menu-options blue" style="font-size: 16px">{{smartEngine.companyInfo.shortname}}({{smartComInfo.code}})</span>
      </div>
      <div class="company-details-head">
        <div class="search-company-list">
          <p><span class="title">法人</span> <span class="mar">{{smartEngine.companyInfo.legalRepresentative}}</span></p>
          <p><span class="title">成立日期</span>  <span class="mar">{{smartEngine.companyInfo.founddate}}</span>
            <span class="title">所属地域</span> <span class="mar">{{smartEngine.companyInfo.area}}</span></p>
        </div>
        <div class="search-company-list last-child">
          <p><span class="title">行业</span> <span class="mar">{{smartEngine.companyInfo.industry}}</span></p>
        </div>
      </div>
      <div class="company-details-box">
        <ul class="one-row-box">
          <li>
            <p class="date"> 公司名称 </p>
            <p class="time"> {{smartEngine.companyInfo.name}} </p>
          </li>
          <li v-if="smartEngine.companyInfo.name_en">
            <p class="date"> 英文名称 </p>
            <p class="time"> {{smartEngine.companyInfo.name_en}} </p>
          </li>
          <li v-if="smartEngine.companyInfo.regcode">
            <p class="date"> 统一社会信用代码 </p>
            <p class="time"> {{smartEngine.companyInfo.regcode}} </p>
          </li>
          <li v-if="smartEngine.companyInfo.regmoney">
            <p class="date">注册资本</p>
            <p class="time"> {{smartEngine.companyInfo.regmoney | formatNumber}}（万元） </p>
          </li>
          <li v-if="smartEngine.companyInfo.secretaries">
            <p class="date"> 董 秘 </p>
            <p class="time"> {{smartEngine.companyInfo.secretaries}} </p>
          </li>
          <li v-if="smartEngine.companyInfo.address">
            <p class="date"> 注册地址 </p>
            <p class="time"> {{smartEngine.companyInfo.address}} </p>
          </li>
          <li v-if="smartEngine.companyInfo.website">
            <p class="date"> 公司网址 </p>
            <p class="time"> {{smartEngine.companyInfo.website}} </p>
          </li>
          <li v-if="smartEngine.companyInfo.phone">
            <p class="date"> 电 话 </p>
            <p class="time"> {{smartEngine.companyInfo.phone}} </p>
          </li>
          <li v-if="smartEngine.companyInfo.fax">
            <p class="date"> 传 真 </p>
            <p class="time"> {{smartEngine.companyInfo.fax}} </p>
          </li>
          <li v-if="smartEngine.companyInfo.postcode">
            <p class="date"> 邮 编 </p>
            <p class="time"> {{smartEngine.companyInfo.postcode}} </p>
          </li>
          <li v-if="smartEngine.companyInfo.companytyp">
            <p class="date"> 企业类型 </p>
            <p class="time"> {{smartEngine.companyInfo.companytyp}} </p>
          </li>
          <li v-if="smartEngine.companyInfo.businessscope">
            <p class="date"> 经营范围 </p>
            <p class="time"> {{smartEngine.companyInfo.businessscope}} </p>
          </li>
        </ul>
      </div>
    </div>
  </div>
          <!-- 评论一下 -->
  <div class="footer-comment" style="bottom:0px;">
    <span class="footer-text"><a href="javascript:;" @click="commentinput = true, content= '',pid = 0"><i class="comment-icon"></i>评论一下</a></span>
    <span class="footer-zan" v-show="!showComments"> <a href="javascript:;" @click="showComments = true,loadcomment()"><span class="qinp"><i></i>{{cpwtotal}}</span></a>
    </span>
    <span class="footer-zan" v-show="showComments"> <a href="javascript:;" @click="showComments = false"><span class="text"><i></i>返回搜索</span></a>
    </span>
  </div>

  <!--评论弹窗-->
  <div aria-hidden="false" aria-labelledby="myModalLabel" role="dialog" tabindex="-1" id="dialog" class="modal fade in" style="display: block;" v-show="commentinput" @click.self="commentinput = false">
    <div class="comment-content">
      <div class="comment-content-tag">
         <div class="login-close">
           <a class="delete-icon" href="javascript:;" @click="commentinput = false"></a>
        </div>
          <div class="comment-reply">
           <textarea cols="" rows="2" class="input-a" placeholder="输入发表内容" v-model="content"></textarea>
           <span class="anonymous" @click="anonym == 1 ? anonym = 0:anonym = 1">
               <label class="el-checkbox mar">
                <span class="el-checkbox-input" :class="{'is-checked':anonym === 1}"><span class="el-checkbox-inner"></span>
                </span>
                <span class="el-checkbox-label">匿名评论</span>
                </label>
             </span>
           <a class="btn-Publish" href="javascript:;" @click="commentinput = false,addComment(2, params.sid)">发表</a>
          </div>
      </div>
    </div>
  </div>

  <div v-if="commentinput" class="ui-datepicker ui-widget ui-widget-content ui-helper-clearfix ui-corner-all" id="ui-datepicker-div"></div>
  <div v-if="commentinput" class="modal-backdrop fade in"></div>

  <bigimg :bigimgobj="bigImgObj"></bigimg>
 </div>
</template>

<script>
  import {apiUrl, dateFormat, alert, isEmptyObj} from '../../helper'
  import $ from 'jquery'
  import userMix from '../../common/userMix'
  import searchMix from '../../common/SearchMix'
  import commentMix from '../notice/commentMix'
  // import myDatepicker from '../../helper/datepicker.vue'
  import wxshareMix from '../../common/wxshareMix'
  import commonMix from '../../common/comSearchMix.js'
  import searchResMix from '../../common/searchResMix.js'
  import BigImg from '../BigImg'
  import resultFrag from './resultFrag'

  export default {
    name: 'ResultView',
    mixins: [userMix, wxshareMix,  searchMix, commentMix, commonMix, searchResMix],
    components: {
      'bigimg': BigImg,
      'resfrag':resultFrag
      // 'date-picker': myDatepicker
    },
    data () {
      return {
        params: {},
        bigImgObj: {'show': false, 'imghead': '', 'imgfoot': '', 'imgurl': ''},
        bottomTip:false,
        stypesArr:[],
        reportTotalPage:null
      }
    },
    route: {
      data ({ to }) {
        this.reportDataList = [];
        console.log(to.query.stype)
        console.log(to.query.uid)
        console.log('Result2组件')
          // 无用户信息，getProfile获取用户信息
        if (!this.currentuser) {
          this.wxcode = this.getQueryString('code')  // 获取微信登录code
          console.log('进入！this.currentuser')
          console.log(this.wxcode)
          if (this.wxcode) {
            this.wxlogin(this.wxcode)
          } else {
            console.log('进入getProfile')
            console.log(to.query.share)
            this.getProfile(to.query)
          }
        }
          // 有用户信息
        if (this.currentuser) {
          console.log('进入this.currentuser')
          console.log(this.currentuser)
          console.log(to.query)
          this.params.uidUrl = to.query.uid
          this.params.share = to.query.share
          this.params.plat = to.query.plat
          this.params.ts = to.query.ts
          // this.params.desc = decodeURI(to.query.desc)
          let descs = window.location.href.split('&')
          console.log(descs)
          for (var i=0,len=descs.length; i<len; i++) {
            let str = descs[i]
            if (str.indexOf('desc=') == 0) {
              // this.params.desc = decodeURI(str.split('=')[1])
              this.params.desc = decodeURIComponent(str.split('=')[1])
              break;
            }
          }
          console.log(to.query)
          this.params.sid = to.query.sid
          this.params.ruid = to.query.ruid
          this.diysharedesc = to.query.desc
          this.stype = to.query.stype
          if (this.checkAction('search/ai')) {
            if (to.query.ai == '1') {
              this.ai = 1
            }
          } else {
            this.ai = 0
          }
          // 清空搜索信息
          this.clearSearch()
          this.datetype = 9
          this.changeStype(parseInt(to.query['stype']))
          console.log('stype end');
          let query = this.parseUrlQuery(to.query)
          this.$data = Object.assign({}, this.$data, query)
          this.addToShow()
          if (!this.isEmptyObj(this.conditions['industrysecond'])) {
            for (let d of this.industry) {
              this.setNum('industrysecond', d)
            }
          }
          if (!this.isEmptyObj(this.conditions['layer'])) {
            this.setNum('plate', this.plates[0])
          }

          console.log('>>>>>>>>>>>>>>> search()');
          this.search()
          // this.gettags()
          this.commentList = []
          this.commentinput = false
          this.showComments = false
          this.getCommentcount(2, this.params.sid)

          // =================================================================
          jQuery(window).unbind()
          $(window).unbind()
          let that = this
          // 滚动判断
          if(this.stype != 100){
            // console.log('滚动滚动滚动滚动滚动滚动滚动滚动滚动滚动滚动滚动滚动滚动')
            $(window).scroll(function() {
            if (($(window).scrollTop() + $(window).height()) >= $(document).height() && that.showComments) {
              let page = that.cpwpage + 1
              if (page <= Math.ceil(that.cpwtotal / 10)) {
                that.getCommentList(page, 2, that.params.sid)
              }
              // that.getCommentList(that.md5)
            }
            let dom = document.documentElement;
            let scrollTop = $(this).scrollTop()       // 滚动条距页顶的距离
            let scrollHeight = $(document).height()   // 浏览器时下窗口文档的高度
            let windowHeight = $(this).height()
            
            // 若滚动到顶部    滚动判断
            if (scrollTop === 0) {
              let top_page = parseInt(that.topPage) - 1;

              if (that.topPage > 1) {  // 最顶部分页页码>1
                that.page = that.topPage;
                that.topPage--;
                if(that.stype == 13){
                  console.log('g㢃大大大萨达撒多撒多')
                  that.reportPage2(that.bottompage)
                  let newReportData = that.reportDataList.concat(that.newItems)
                  that.reportDataList = newReportData
                } else {
                that.paging2(that.topPage);
                let newDetailLists = that.newItems.concat(that.detailLists);
                that.detailLists = newDetailLists;
                }

                that.$nextTick(function () {
                  let resultList10 = $('.search-result-list')[4]
                  let offsetTop = resultList10.offsetTop
                  let offsetHeight = resultList10.offsetHeight
                  let newOffsetTop = offsetTop + offsetHeight
                  $(window).scrollTop(newOffsetTop)
                })
              }
            }
            // 滚动到底部
            if (scrollTop + windowHeight >= scrollHeight) {
              console.log('滚动到底部')
              let next_page = parseInt(that.bottomPage) + 1;
              let totals;
              if(that.stype == 13){
                totals = that.reportTotalPage;
              } else {
                totals = that.totalPage;
              }
              if (that.bottomPage < totals) {  // 最底部分页页码<总页数
                that.page = that.bottomPage
                that.bottomPage++
                if(that.stype == 13){
                  console.log(that.bottomPage)
                  console.log('xxxxxg㢃大大大萨达撒多撒多')
                  that.reportPage2(that.bottomPage)
                  let newReportData = that.reportDataList.concat(that.newItems)
                  that.reportDataList = newReportData
                } else {
                  that.paging2(that.bottomPage)
                  let newDetailLists = that.detailLists.concat(that.newItems)
                  that.detailLists = newDetailLists
                }
              } else {
                that.bottomTip = true
                setTimeout(function(){
                  dom.scrollTop = scrollHeight-windowHeight-40;
                },800)
              }
            }
          })
          }
          this.getTagLists()

          // 微信分享
          this.$nextTick(function () {
            let that = this
            let wxsharedesc = that.getResultShareDesc()
            let wxsharetitle = that.getResultShareTitle()
            that.getwxsign()  // 微信签名

            that.shareResult(wxsharetitle, wxsharedesc)  //分享结果
            if (this.params.desc && this.params.desc !='') {
              document.title = this.params.desc;
            } else {
              document.title = 'IBDATA:智能投研第一品牌';
            }
          })
        }
      }
    },
    methods: {
      setBigImgObj: function (item, article) {
        this.bigImgObj.imghead = item.imghead
        this.bigImgObj.imgfoot = item.imgfoot
        this.bigImgObj.imgurl = item.imgurl
        this.bigImgObj.imgid = item.imgid

        this.bigImgObj.companycode = article.companyCode;
        this.bigImgObj.companyname = article.companyName;
        this.bigImgObj.md5 = article.id;
        this.bigImgObj.publishdate = article.publishDate;
        // this.bigImgObj.shortname = article.shortname;
        this.bigImgObj.stype = this.stype;
        this.bigImgObj.title = article.title;

        this.bigImgObj.show = true
      },
      /**
       * 分页
       */
      // paging (page) {
      //   this.go(page)
      // },
      loadcomment: function () {
        if (this.commentList.length == 0) {
          this.getCommentList(1, 2, this.params.sid)
        }
      },
      go (page) {
        this.page = page || 1
        let query = this.genUrlQuery()
        query.ruid = this.params.uidUrl
        query.uid = this.uid
        this.$route.router.go({ path: '/result', query: query })
      },
      search () {
        console.log('进入search搜索信息')
        console.log(this.stype)
        this.loading = true
        let keywords = this.keywords.trim()    // 关键词
        this.companyCode = this.companyCode.trim()  // 证券代码
        if (!this.companyCode && this.stype !== 4 && !this.validKeywordCondition() && !this.keywords) {
          alert('请输入关键词或股票代码')
          return
        }

        // 清除前一次智能引擎数据
        this.finance = []
        this.yearfinance = []
        this.smartEngine.open = false
        this.smartEngine.companyInfo = {}

        let query = this.genQuery()   // 查询条件
        query.perPage = 5
        query.uid = parseInt(this.params.uidUrl)
        query.share = this.params.share
        query.plat = this.params.plat
        query.sid = this.params.sid
        query.ruid = this.params.ruid
        let page = query.page
        this.topPage = page
        this.bottomPage = page
        this.page = page
        this.initAnaly()
        let requrl = '';
        if(this.stype == 100){
          console.log(this.page)
          console.log(this.loading)
          this.complex()
        } else if(this.stype == 13){
          this.reportData(this.stype);
        } else {
          // stype == 1 或 2 调用search3b接口,否则调用search接口
          if (this.stype === 1 || this.stype === 2) {  // A股或新三板
            requrl = apiUrl('/V1.0.0/notice/searchn3b')
          } else {
            console.log('进入search接口信息页面')
            console.log(this.stype)
            requrl = apiUrl('/V1.0.0/notice/search')
          }
        $.ajax({
          url: requrl,
          method: 'post',
          dataType: 'json',
          data: JSON.stringify(query)
        }).done((response) => {
          this.loading = false
          this.analyze()    // 分析
          if (response.status === 0) {
            let items = response.lists
            for (let item of items) {
              item.checked = false
              if (item.child) {
                for (let child of item.child) {
                  child.showque = false
                  if (child.answers) {
                    for (let ans of child.answers) {
                      ans.showans = false
                    }
                  }
                }
              }
            }
            this.items = items    // 当前页数据
            this.detailLists = items
            this.total = response.total
            let totalPage = Math.ceil(this.total / this.perPage)
            this.totalPage = totalPage
            this.searched = this.stype    // 公告类型
            // -------------------------------------------------------------------
            if (response.company) {
              this.smartComInfo = response.company[0] || {}
              if (this.smartComInfo.finance && this.smartComInfo.finance.length > 0) {
                let a = [' ']
                for (let k in this.smartComInfo.finance[0]) {
                  if (k !== 'plate' && k !== 'reportdate' && k !== 'reportdatestr') {
                    a.push(k)
                  }
                }
                this.finance.push(a)
                this.yearfinance.push(a)
                for (let item of this.smartComInfo.finance) {
                  let arr = []
                  if (item.plate === 'A') {
                    for (let i in item) {
                      if (i !== 'plate' && i !== 'reportdatestr') {
                        arr.push(item[i])
                      }
                    }
                    this.finance.push(arr)
                  } else {
                    for (let i in item) {
                      if (i !== 'plate' && i !== 'reportdate') {
                        arr.push(item[i])
                      }
                    }
                    this.finance.push(arr)
                  }
                }
                for (let i of this.finance) {
                  if (this.smartComInfo.type === 'A') {
                    if (i[0] && i[0].indexOf('-12-') > 0) {
                      this.yearfinance.push(i)
                    }
                  } else {
                    if (i[0] && i[0].indexOf('年报') > 0) {
                      this.yearfinance.push(i)
                    }
                  }
                }
                this.finance.sort(function (a, b) {return parseInt(b[0].replace(/-/g, '')) - parseInt(a[0].replace(/-/g,''))})
                this.yearfinance.sort(function (a, b) {return parseInt(b[0].replace(/-/g, '')) - parseInt(a[0].replace(/-/g,''))})

              } else {
                this.finance = []
                this.yearfinance = []
              }
              this.prices = this.smartComInfo.price || {}
              if (this.prices.trade && this.prices.settlement) {
                this.upanddown = (this.prices.trade - this.prices.settlement).toFixed(2)
                if (this.upanddown > 0 || this.upanddown == 0) {
                  this.upanddown = '+' + this.upanddown
                }
                this.Amplitude = ((this.prices.trade - this.prices.settlement)/ this.prices.settlement * 100).toFixed(2)
                if (this.Amplitude > 0) {
                  this.Amplitude = '+' + this.Amplitude
                }
              }
            } else {
              this.smartComInfo = {}
            }
            // -------------------------------------------------------------------
            // 如果分享过来时是第一页
            if (this.page !== 1) {
              this.$nextTick(function () {
                $(window).scrollTop(23)
              })
            }
          } else if (response.status === 502) {
            alert('很抱歉，请求超时请重新搜索')
          }
        }).fail((response) => {
          this.loading = false
          alert('请求失败')
        })
        }
      },
      // 搜索，点击搜索按钮执行
      mySearch () {
        if (this.currentRegtyp === 4) {   // 未绑定微信，提示去绑定
          this.tipGoBind = true
          return
        }

        // 清除前一次智能引擎数据
        // this.finance = []
        // this.yearfinance = []
        // this.smartEngine.open = false
        // this.smartEngine.companyInfo = {}

        let keywords = this.keywords.trim()
        this.companyCode = this.companyCode.trim()
        if (!this.companyCode && this.stype !== 4 && !this.validKeywordCondition() && !keywords) {
          alert('请输入关键词或股票代码')
          return
        }
        this.switchPage(2)
        this.page = 1
        let query = this.genUrlQuery()
        query.ai = this.ai
        query.uid = this.params.uidUrl
        query.share = this.params.share
        query.plat = this.params.plat
        query.ruid = this.params.ruid
        query.sid = this.params.sid
        console.log(query)
        this.$route.router.go({ path: '/result', query: query })
      },
      slideDropdown2 (e) {
        let el = e.currentTarget
        let nextNode = el.nextElementSibling   // 目标元素下一个兄弟节点
        let elClass = nextNode.getAttribute('class'),
          class1 = elClass.split(' ')[0],
          class2 = elClass.split(' ')[1]    // close or open
        // 1. 点击按钮本身，隐藏其他已打开的拉开框
        $('.date-menu').each(function () {
          if ($(this).hasClass('open')) {
            $(this).removeClass('open').addClass('close')
          }
        })
        // 2. 每次只打开当前下拉框
        if (class2 === 'close') {
          let _class = class1 + ' ' + 'open'
          nextNode.setAttribute('class', _class)
        }
        if (class2 === 'open') {
          let _class = class1 + ' ' + 'close'
          nextNode.setAttribute('class', _class)
        }
      },
      alertDateModal () {
        this.showDateModal = true
        this.oldDatetype = this.datatype
        this.oldStartdate = this.startdate
        this.oldEnddate = this.enddate
      },
      searchMore(stype){
        this.loading = true;
        this.changeStype(stype)
        this.mySearch();
      },
      reportData(stype){
        let query = this.genQuery();
        query.stypes = [stype];
        query.perPage = 10;
        $.ajax({
          url: apiUrl('/V1.0.0/notice/searchall'),
          method: 'post',
          dataType: 'json',
          data: JSON.stringify(query)
        }).done((response) => {
          this.loading = false;
          if(response.status == 0){
            this.reportDataList = response.data[stype].lists;
            this.reportDataTotal = response.data[stype].total;
            this.reportTotalPage = Math.ceil(this.reportDataTotal/10);
            console.log(this.reportTotalPage)
            console.log('打印totalpage的页面')
            this.bottompage = 1;
            this.$nextTick(()=>{
              document.documentElement.scrollTop = 0
            })
          }
        })
      },
    },
  }
</script>

<style scoped>
  .loading_gif {
    position: absolute;
    width: 100%;
    height: 100%;
    margin-top: 0;
    z-index: 2999;
    background-color: rgba(0, 0, 0, .7);
  }

  .loading_gif img {
    margin-top: 48%;
  }

  .small-delete {
    display: block;
    width: 17px;
    height: 20px;
    float: right;
    margin-right: 12px;
    background-image: url("../../../static/images/icon-delete.svg");
    background-size: cover;
    margin-top: 4px;
  }

  .blue {
    font-size: 14px;
    font-weight: 700;
  }
  .text-a {
    font-size: 14px;
  }

  p {
    text-indent: 0;
  }

  /* 加载更多 */

  .more,
  .more_top {
    height: 1.2rem;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #333;
  }
  .pull_icon,
  .pull_icon_top {
    width: 25px;
    height: 25px;
    /*background-image: url('../images/pull.png');*/
    /*background-image: url('../../../static/images/pull.png');*/
    background-repeat: no-repeat;
    background-position: center;
    background-size: 25px;
    transition: all .5s;
  }
  .more span,
  .more_top span {
    padding-left: .5rem;
  }


  .more .flip,
  .more_top .flip {
    transform: rotate(180deg);
  }
  .loading{
    /*background-image: url('../images/loading.png');*/
    background-image: url('../../../static/images/loading.png');
    background-repeat: no-repeat;
    background-position: center;
    background-size: 25px;
  }
  .more .loading,
  .more_top .loading {
    -webkit-transform: rotate(0deg) translateZ(0);
    -webkit-transition-duration: 0;
    -webkit-animation-name: loading;
    -webkit-animation-duration: 2s;
    -webkit-animation-iteration-count: infinite;
    -webkit-animation-timing-function: linear;
  }

  @-webkit-keyframes loading {
    from {
      -webkit-transform: rotate(0deg) translateZ(0);
    }
    to {
      -webkit-transform: rotate(360deg) translateZ(0);
    }
  }
  .search-result-list:nth-child(1) {
    margin-top: .5rem;
  }

/*  .Screen-criteria-head .fr {
    width: 0.6rem;
    height: 0.6rem;
    margin-top: 0.8rem;
  }*/

  .f3{
    float: right;
    width: 0.55rem;
    height: 0.32rem;
    margin-right: 0.5rem;
    margin-top: 0.98rem;
    color: #1E88E5;
    font-size: 0.8rem;
    background-image: url(/static/images/expand-more-a.png);
    background-size: 100%;
  }
  
  .Screen-criteria-head span.close {
    background-image: url("../../../static/images/icon-slidedown.svg") !important;
    background-size: cover;
    height:0.6rem;
  }

  .Screen-criteria-head span.open {
    background-image: url("../../../static/images/icon-slideup.svg") !important;
    background-size: cover;
  }

  /*自定义分享日期*/
  .search-date-custom .time .l,
  .search-date-custom .time .r {
    /*display: inline-block;*/
    /*width: 24%;*/
  }

  .cov-vue-date {
    width: 100%;
  }

  .datepickbox {
    width: 100%;
  }

  .datepickbox input {
    width: 100% !important;
    padding: 0px !important;
  }

  .cov-datepicker {
    border: none;
  }

  /*-------------------------------------------搜索页 --------------------------------------*/
  .cov-date-body {
    width: 80% !important;
    margin-left: -7.4% !important;
  }

  .loading_gif {
    position: absolute;
    width: 100%;
    height: 100%;
    margin-top: 0;
    z-index: 2999;
    background-color: rgba(0, 0, 0, .7);
  }

  .loading_gif img {
    margin-top: 48%;
  }

  .date-slide-menu {
    background: #FFFFFF;
    /*width: 13rem;*/
    -webkit-box-shadow: 0 10px 6px -6px #777;
    -moz-box-shadow: 0 10px 6px -6px #777;
    box-shadow: 0 10px 6px -6px #777;
    border: 1px solid #e0dddd;
  }

  .select-name {
    float: left;
    width: 90%;
  }
  .arrow-img {
    float: right;
    width: 25px;
    height: 25px;
  }

  .arrow-img img {
    max-width: 100%;
  }

  .home-nav-app > .lanmu {
    top: 1.2rem;
  }
  .el-checkbox {
    width: 100%;
  }

  .el-checkbox .qicon {
    float: right;
    margin-right: 1.2rem;
    background-size: cover;
    margin-top: 6px;
    height: .6rem;
    width: .8rem;
  }

  .el-checkbox .qicon.close {
    background: url("../../../static/images/icon-slidedown.svg");
    background-size: cover;
  }

  .el-checkbox .qicon.open {
    background: url("../../../static/images/icon-slideup.svg");
    background-size: cover;
  }

  .dio .second {
    text-indent: .5rem;
  }

  .release-date .date-menu.close,
  .search-input .date-menu.close {
    display: none;
  }

  .release-date .date-menu.open,
  .search-input .date-menu.open {
    display: block;
  }

  /*发布日期*/
  .r cov-vue-date .datepickbox input {
    text-align: right;
  }

/*  .Release-date .time .r {
    width: 5rem;
  }*/
  /*------------------------------------------- / 搜索页 ----------------------------------*/
  .modal {
    display: block;
  }

  table {
    font-size: 0.7rem;
  }

  table td {
    font-size: 0.7rem;
  }
  /* .search-tab::-webkit-scrollbar {
     width: 0;
  } */
  .activeTyp{
    border-bottom:0.175rem solid #f8bbd0 !important;
    color: #f8bbd0;
  }
  .search-tab-scroll{
    width:100%;
    overflow:hidden;
    overflow-x:auto;
  }
  .search-tab-scroll ul{
    width:150%;
  }
  .search-tab-scroll ul li{
    float: left;
    width: 10%;
  }
</style>



/** WEBPACK FOOTER **
 ** Result2.vue?4a704226
 **/